import { connect } from 'react-redux';

import { getAdmins, deleteAdmin, search } from '../actions/admins';
import clearError from '../actions/global';
import Admins from '../views/Admins';

function mapStateToProps({ admins }) {
  return { ...admins };
}

export default connect(mapStateToProps, { getAdmins, deleteAdmin, clearError, search })(Admins);



// WEBPACK FOOTER //
// ./src/containers/AdminsContainer.js